import React from 'react';
import { Button, CodeSnippet, InlineLoading } from 'carbon-components-react';
import { useDispatch } from 'react-redux';
import {
  addArcgisPasswordStart,
  deleteArcgisPasswordStart
} from 'redux/arcgis';

const CredentialForm: React.FC<Props> = ({
  username,
  password,
  processing
}) => {
  const dispatch = useDispatch();

  return (
    <div className="gis-integration-credential-container">
      <div className="gis-integration-credential-form">
        <div className="bx--form-item bx--text-input-wrapper">
          <div className="gis-integration-credential-username-container">
            <label className="gis-integration-credential-username-label bx--label">
              Username
            </label>
          </div>
          <div className="bx--text-input__field-outer-wrapper">
            <div className="bx--text-input__field-wrapper">
              <CodeSnippet
                type="single"
                className="gis-integration-credential-username-snippet"
                onClick={() => navigator.clipboard.writeText(username)}
                hideCopyButton={!username}
              >
                {username}
              </CodeSnippet>
            </div>
          </div>
        </div>

        <div className="bx--form-item bx--text-input-wrapper">
          <div className="gis-integration-credential-password-container">
            <label className="gis-integration-credential-password-label bx--label">
              Password
            </label>
            {!processing && (
              <Button
                kind="ghost"
                className="gis-integration-credential-password-btn"
                onClick={() => dispatch(addArcgisPasswordStart(true))}
              >
                New password
              </Button>
            )}
          </div>
          <div className="bx--text-input__field-outer-wrapper">
            <div className="bx--text-input__field-wrapper">
              {password ? (
                <CodeSnippet
                  type="single"
                  className="gis-integration-credential-password-snippet"
                  onClick={() => navigator.clipboard.writeText(password)}
                  hideCopyButton={!password}
                >
                  {password}
                </CodeSnippet>
              ) : (
                <input
                  id="gis-integration-credential-password-readonly-input"
                  className="bx--text-input bx--text__input"
                  type="password"
                  value="**********"
                  readOnly={true}
                />
              )}
            </div>
          </div>
        </div>
      </div>
      <div className="gis-integration-credential-action">
        {processing ? (
          <InlineLoading
            description={
              processing === 'adding' ? 'Generating...' : 'Deleting...'
            }
          />
        ) : (
          <Button
            kind="secondary"
            size="field"
            onClick={() => dispatch(deleteArcgisPasswordStart())}
          >
            Delete credentials
          </Button>
        )}
      </div>
    </div>
  );
};

type Props = {
  username: string;
  password?: string;
  processing?: string;
};

export default React.memo(CredentialForm);
